import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '..';
import { TaskTracker } from '../TaskTracker/TaskTracker';
import './MilestoneTracker.scss';

const MilestoneTracker = ({ milestones, formatCurrency, formatDate }) => {
  return (
    <TaskTracker
      items={milestones}
      title='Project Progress'
      emptyTitle='No Milestones Defined'
      emptyMessage="This contract doesn't have any milestones tracking yet."
      renderContent={(milestone, index, status) => (
        <div className={`milestone-content-card ${status}`}>
          <div className='card-header'>
            <div className='header-main'>
              <span className='task-number'>Milestone {index + 1}</span>
              <h4 className='task-title'>{milestone.title}</h4>
            </div>
            <div className='header-meta'>
              <span className='milestone-amount'>
                {formatCurrency
                  ? formatCurrency(milestone.amount_usd)
                  : `$${milestone.amount_usd}`}
              </span>
              <span className={`status-badge ${status}`}>
                {status.replace('_', ' ')}
              </span>
            </div>
          </div>

          {milestone.description && (
            <p className='task-description'>{milestone.description}</p>
          )}

          <div className='card-footer'>
            {milestone.due_date && (
              <div className='meta-item'>
                <Icon name='Calendar' size={14} />
                <span>
                  Due:{' '}
                  {formatDate
                    ? formatDate(milestone.due_date)
                    : milestone.due_date}
                </span>
              </div>
            )}
            {milestone.completed_at && (
              <div className='meta-item completed-date'>
                <Icon name='Check_Circle' size={14} />
                <span>
                  Completed:{' '}
                  {formatDate
                    ? formatDate(milestone.completed_at)
                    : milestone.completed_at}
                </span>
              </div>
            )}
          </div>
        </div>
      )}
    />
  );
};

MilestoneTracker.propTypes = {
  milestones: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
      amount_usd: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      description: PropTypes.string,
      due_date: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
      ]),
      is_completed: PropTypes.bool,
      completed_at: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
      ]),
    })
  ).isRequired,
  formatCurrency: PropTypes.func,
  formatDate: PropTypes.func,
};

export default MilestoneTracker;
